module.exports = {
  title: '资讯管理',
  route: {
    path: '/infomation-dynamic',
    children: {
      path: 'infomation-list',
    },
  },
};
